import React, { useState } from "react";
import cn from "classnames";
import styles from "./Share.module.sass";
import Icon from "../Icon";
import OutsideClickHandler from "react-outside-click-handler";

const Share = ({ className, openUp, darkButton, url, title, description }) => {
  // Utiliser l'URL fournie ou l'URL actuelle de la page
  const shareUrl = url || window.location.href;
  const [visible, setVisible] = useState(false);

  // Fonctions pour créer les URLs de partage
  const getTwitterShareUrl = () => {
    const articleTitle = title || document.title || "Article intéressant";
    const text = encodeURIComponent(`${articleTitle} - Découvrez cet article sur Edutio !`);
    return `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${text}&hashtags=Edutio,Formation,Apprentissage`;
  };

  const getFacebookShareUrl = () => {
    const params = new URLSearchParams({
      u: shareUrl,
      quote: title ? `${title} - Découvrez cet article sur Edutio !` : "Découvrez cet article intéressant sur Edutio !"
    });
    return `https://www.facebook.com/sharer/sharer.php?${params.toString()}`;
  };
  return (
    <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
      <div
        className={cn(
          className,
          styles.share,
          { [styles.openUp]: openUp },
          { [styles.darkButton]: darkButton }
        )}
      >
        <button
          className={cn(
            "button-circle-stroke button-small",
            { [styles.active]: visible },
            styles.button
          )}
          onClick={() => setVisible(!visible)}
        >
          <Icon name="download" size="22" />
        </button>
        <div className={cn(styles.body, { [styles.show]: visible })}>
          <div className={styles.title}>Partager</div>
          <div className={styles.list}>
            <a 
              href={getTwitterShareUrl()} 
              target="_blank" 
              rel="noopener noreferrer" 
              className={styles.link}
            >
              <span>
                <Icon name="twitter" size="20" />
              </span>
            </a>
            <a 
              href={getFacebookShareUrl()} 
              target="_blank" 
              rel="noopener noreferrer" 
              className={styles.link}
            >
              <span>
                <Icon name="facebook" size="20" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </OutsideClickHandler>
  );
};

export default Share;
